var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate__animated animate__fadeInUp"},[_c('div',{staticClass:"titulo"},[_c('h2',[_vm._v(_vm._s(_vm.dataTextosInicialesNarradores.titulo_narradores))])]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.dataTextosInicialesNarradores.texto_narradores)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }